import {
  Badge,
  Box,
  Button,
  Container,
  Heading,
  Image,
  ListItem,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import webappImage from "../../../resources/images/webapp.png";
import { useNavigate } from "react-router-dom";

const MyOrdersTease = () => {
  const navigate = useNavigate();
  return (
    <>
      <Container>
        <Box bg="black">
          <Image w="" src={webappImage} alt="Redwing Web App" />
        </Box>
        <Box width="100%">
          <Box bg="gray.700" borderBottomRadius="lg" p="6">
            <Badge color="white">New</Badge>
            <Heading size="md" mb="6">
              Introducing your own collection of reading orders
            </Heading>
            <Text>
              Create your own reading orders via our website and save them into
              your own collection that you can then find in your mobile app.
            </Text>
            <br />
            <UnorderedList>
              <ListItem>
                Create your own reading orders, from existing ones or from
                scratch
              </ListItem>
              <ListItem>
                Access them on-the-go directly from our mobile app
              </ListItem>
              <ListItem>
                Share your orders with other readers or keep them private
              </ListItem>
              <ListItem>Create reading lists for your book club group</ListItem>
            </UnorderedList>
            <Button
              mt="3"
              colorScheme="red"
              textColor="white"
              onClick={() => navigate("/go-premium")}
            >
              Create your own reading order
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default MyOrdersTease;
